import { render, staticRenderFns } from "./custom-company-exhibition.vue?vue&type=template&id=31f9b8e8&scoped=true&"
import script from "./custom-company-exhibition.vue?vue&type=script&lang=js&"
export * from "./custom-company-exhibition.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-exhibition.vue?vue&type=style&index=0&id=31f9b8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9b8e8",
  null
  
)

export default component.exports